import { Container } from '@mui/material'
import React from 'react'
import { useDispatch } from 'react-redux'
import * as Yup from 'yup'
import Header from '../form/Header'
import { formTypeList } from '../../constants/form'
import AppForm from '../form/AppForm'
import AppSelect from '../form/AppSelect'
import selectList from '../../constants/selectList.json'
import AppInput from '../form/AppInput'
import SubmitButton from '../form/SubmitButton'
import { addNewStoreCredit } from '../../store/actions/customerAction'
import { updateStoreCredit } from '../../store/actions/storeCreditAction'

const validationSchema = Yup.object().shape({
    payType: Yup.string().required().label('Pay Type'),
    creditAmount: Yup.number().required().label('Amount'),
    creditDate: Yup.string().required().label('Credit Date'),
})

const StoreCreditForm = ({
    formType,
    setOpen,
    customerId,
    propsValue = null,
}) => {
    const dispatch = useDispatch()
    return (
        <Container>
            <Header
                title={`${formType === formTypeList.NEW ? 'ADD' : ''}${
                    formType === formTypeList.EDIT ? 'EDIT' : ''
                } ORDER PAYMENT`}
            />
            <AppForm
                initialValues={{
                    payType: propsValue
                        ? propsValue.payType
                        : selectList.paymentTypeDW.default,
                    cardNo: propsValue ? propsValue.cardNo : '',
                    cardType: propsValue ? propsValue.cardType : '',
                    creditAmount: propsValue ? propsValue.creditAmount : 0,
                    creditDate: propsValue ? propsValue.creditDate : '',
                    refNo: propsValue ? propsValue.refNo : '',
                    message: propsValue ? propsValue.message : '',
                }}
                onSubmit={(values) => {
                    const submitValues =
                        formType === formTypeList.NEW
                            ? { ...values, customerId }
                            : { ...propsValue, ...values }
                    formType === formTypeList.NEW
                        ? dispatch(addNewStoreCredit(submitValues))
                        : dispatch(updateStoreCredit(submitValues))
                    setOpen(false)
                }}
                validationSchema={validationSchema}
            >
                <AppSelect
                    name="payType"
                    label="Pay Type"
                    options={
                        process.env.REACT_APP_CLIENT === 'dw'
                            ? selectList.paymentTypeDW.list
                            : selectList.paymentTypeWLink.list
                    }
                />
                <AppInput
                    name="cardNo"
                    label="Card No"
                    type="text"
                    inputProps={{ maxLength: 20 }}
                />
                <AppInput
                    name="cardType"
                    label="Card Type"
                    type="text"
                    inputProps={{ maxLength: 20 }}
                />
                <AppInput
                    name="creditAmount"
                    label="Amount"
                    type="number"
                    inputProps={{ maxLength: 10 }}
                    required={true}
                />
                <AppInput
                    name="creditDate"
                    // label="Payment Date"
                    type="date"
                    inputProps={{ maxLength: 20 }}
                    required={true}
                />
                <AppInput
                    name="refNo"
                    label="Reference No"
                    type="text"
                    inputProps={{ maxLength: 50 }}
                />
                <AppInput
                    name="message"
                    label="Message"
                    type="text"
                    inputProps={{ maxLength: 50 }}
                />
                <SubmitButton title="Submit" />
            </AppForm>
        </Container>
    )
}

export default StoreCreditForm
